import React from "react";
import { Link } from "gatsby";
import Container from "./container";
import { cn } from "../lib/helpers";
import Icon from "./icon";

import * as styles from "../styles/components/plans.module.css";

function Plans({ items, partnerSite }) {
  return (
    <div className={styles.root}>
      <Container>
        <div className={cn("grid justify-center", styles.items)}>
          {items.map(({ _key, title, description, price, duration, button, features, link }) => {
            return (
              <div className={cn("col-12 col-md-6 col-xl-3 col-xxl", styles.item)} key={_key}>
                <div className={styles.inner}>
                  {title && <h4 className={styles.title}>{title}</h4>}
                  {description && <p className={styles.description}>{description}</p>}
                  <div style={{marginBottom: '15px'}}>
                    {partnerSite && <a href={link?.url} target="_blank" rel="noreferrer">{link?.text}</a>}
                  </div>
                  {price && 
                    <div className={styles.price}><span className="h5">{price}</span>{duration && <span className={styles.duration}> {duration}</span>}</div>
                  }
                  {button && button.url && 
                    <>
                      {button.blank
                        ? <a href={button.url} className={cn("btn", button.secondaryButton && "secondary")} target="_blank" rel="noreferrer">{button.text}</a>
                        : <Link to={button.url} className={cn("btn", button.secondaryButton && "secondary")}>{button.text}</Link>
                      }
                    </>
                  }
                  {features &&
                    <div className={styles.features}>
                      <ul>
                        {features.map(node => {
                          return (
                            <li><Icon symbol="check" />{node}</li>
                          );
                        })}
                      </ul>
                    </div>
                  }
                  {link && link.url && !partnerSite && 
                    <a href={link.url} className={styles.link} target="_blank" rel="noreferrer"><Icon symbol="document" />{link.text}</a>
                  }
                </div>
              </div>
            );
          })}
        </div>
      </Container>
    </div>
  );
}

export default Plans;
